// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__3-qwU","Logo":"Toolbar_Logo__1gSqU","forsp":"Toolbar_forsp__39ef1","active":"Toolbar_active__1tDFQ"};